// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*
The Vuetify toolbar height is based on screen width breakpoints
The toolbar can be 48px, 56px and 64px.
It is fixed to 48px when using 'dense'

The message list is placed between the toolbar at the top and input
container on the bottom. Both the toolbar and the input-container
dynamically change height based on width breakpoints.
So we duplicate the height and substract it from the total height
of the message list to make it fit between the toolbar and input container

NOTE: not using var() for different heights due to IE11 compatibility
*/

/* Concierge Assistant Styling */
#lex-web[data-v-50a86736] {
  background-color: transparent;
  font-family: 'Roboto', sans-serif;
  position: relative;
}
#lex-web.ui-minimized[data-v-50a86736] {
  background: transparent;
}

/* Floating chat button styling */
.floating-chat-button[data-v-50a86736] {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}
.chat-toggle-btn[data-v-50a86736] {
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 0 20px;
  background-color: #0e365c !important;
  color: white !important;
}
.chat-toggle-btn[data-v-50a86736]:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  background-color: #0f4070 !important;
}

/* Chat container styling */
.chat-container[data-v-50a86736] {
  position: fixed;
  width: 400px;
  height: 600px;
  max-height: 90vh;
  bottom: 20px;
  right: 20px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 1000;
}
.chat-content-area[data-v-50a86736] {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100% - 60px - 70px); /* Subtract header height and input container height */
  overflow: hidden;
  position: relative;
}
.chat-main[data-v-50a86736] {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.message-list-container[data-v-50a86736] {
  padding: 0;
  background-color: #fefefe;
  height: 100% !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}
.concierge-messages[data-v-50a86736] {
  height: 100%;
  width: 100%;
  max-width: 100%;
  transition: opacity 0.3s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.concierge-input[data-v-50a86736] {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 8px 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 10;
  transition: all 0.3s ease;
  width: 100%;
  height: 70px; /* Fixed height for input container */
}
.input-hidden[data-v-50a86736] {
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px);
  transition: all 0.3s ease;
}
.input-visible[data-v-50a86736] {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
  transition: all 0.3s ease;
}

/* Positioning for minimized/maximized states */
.chat-minimized[data-v-50a86736] {
  transform: translateY(calc(100% + 20px));
  opacity: 0;
  pointer-events: none;
  transition: transform 0.4s ease, opacity 0.3s ease;
}
.chat-maximized[data-v-50a86736] {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
  transition: transform 0.4s ease, opacity 0.3s ease;
}

/* When in fullscreen mode */
.chat-fullscreen[data-v-50a86736] {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  transform: none !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  border-radius: 0 !important;
  z-index: 1001 !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  box-shadow: none !important;
  overflow:scroll!important;
}
.message-list-container.fullscreen-mode[data-v-50a86736] {
  height: calc(100vh - 180px) !important; /* Adjusted for header + input container */
}
.main-hidden[data-v-50a86736] {
  opacity: 0;
  pointer-events: none;
}
.messages-hidden[data-v-50a86736] {
  opacity: 0;
  pointer-events: none;
}

/* Chat header styling */
.chat-header[data-v-50a86736] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #143659;
  color: #ffffff;
  height: 60px;
  position: sticky;
  top: 0;
  z-index: 10;
}
.header-left[data-v-50a86736] {
  display: flex;
  align-items: center;
}
.menu-dropdown[data-v-50a86736] {
  position: relative;
  display: inline-block;
}
.menu-btn[data-v-50a86736] {
  border-radius: 50%;
  min-width: 36px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  margin-right: 8px;
}
.menu-btn[data-v-50a86736]:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

/* Previous button styling */
.prev-btn[data-v-50a86736] {
  border-radius: 50%;
  min-width: 36px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  margin-right: 12px;
}
.prev-btn[data-v-50a86736]:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.prev-icon[data-v-50a86736] {
  font-size: 18px;
  line-height: 1;
}
.chat-title[data-v-50a86736] {
  font-size: 1.2rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.5px;
}
.chat-controls[data-v-50a86736] {
  display: flex;
  gap: 8px;
}
.control-btn[data-v-50a86736] {
  border-radius: 50%;
  min-width: 36px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2);
  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
  color: white;
  font-size: 16px;
  margin-left: 8px;
}
.control-btn[data-v-50a86736]:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
.control-btn .icon[data-v-50a86736] {
  font-size: 14px;
  line-height: 1;
}
.minimize-btn .icon[data-v-50a86736] {
  margin-top: -8px;
}
.close-btn[data-v-50a86736]:hover {
  background-color: rgba(255, 0, 0, 0.3);
}
.icon-chat[data-v-50a86736] {
  display: none;
}

/* End Chat Button Styling */
.end-chat-btn[data-v-50a86736] {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 20px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  margin-right: 70px!important;
}
.end-chat-btn[data-v-50a86736]:hover {
  background-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}
.end-chat-text[data-v-50a86736] {
  font-size: 14px;
  font-weight: 500;
}
.end-chat-icon[data-v-50a86736] {
  font-size: 16px;
}
.dropdown-content[data-v-50a86736] {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 20;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 5px;
}
.dropdown-item[data-v-50a86736] {
  color: #143659;
  padding: 12px 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}
.dropdown-item[data-v-50a86736]:hover {
  background-color: #f7f9fc;
  transform: translateX(3px);
}
.dropdown-icon[data-v-50a86736] {
  margin-right: 8px;
  font-size: 18px;
}
.dropdown-text[data-v-50a86736] {
  font-size: 14px;
}
.ask-us-icon[data-v-50a86736] {
  width: 80px;
  height: 80px;
}
.chat-toggle-btn.icon-only[data-v-50a86736] {
  min-width: auto !important;
  padding: 0 !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.chat-toggle-btn.icon-only[data-v-50a86736]:hover {
  transform: translateY(-3px);
  background-color: transparent !important;
}
@media (max-width: 600px) {
.chat-container[data-v-50a86736] {
    width: 100%;
    height: 80%;
    bottom: 0;
    right: 0;
    border-radius: 16px 16px 0 0;
}
.chat-minimized[data-v-50a86736] {
    transform: translateY(100%);
}
.floating-chat-button[data-v-50a86736] {
    bottom: 10px;
    right: 10px;
}
}
html[data-v-50a86736] { 
  font-size: 14px !important;
}
.v-application[data-v-50a86736] {
  line-height: 1.5;
  letter-spacing: 0.3px;
}
.v-btn[data-v-50a86736] {
  letter-spacing: 0.5px;
  text-transform: none;
  font-weight: 500;
}
.v-toolbar__title[data-v-50a86736] {
  font-weight: 500;
  letter-spacing: 0.5px;
}
.fade-transition-enter-active[data-v-50a86736], .fade-transition-leave-active[data-v-50a86736] {
  transition: opacity 0.3s ease;
}
.fade-transition-enter[data-v-50a86736], .fade-transition-leave-to[data-v-50a86736] {
  opacity: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
